module.exports = __webpack_public_path__ + "static/media/h250_13.1168889a5cd41fdbc22e54b988ccf49d.png";